import React from 'react';
// B-Design only applies style to Loading component.
import PageHeader from 'antd/es/page-header';
import { ConfigContext } from '../config-provider';
import { PageHeaderProps } from 'antd/es/page-header';
const BdPageHeader = (props) => {
    const { prefixCls, ...otherProps } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const classPrefix = getPrefixCls('page-header', prefixCls);
    return React.createElement(PageHeader, { prefixCls: classPrefix, ...otherProps });
};
export default BdPageHeader;
